module.exports = __webpack_public_path__ + "img/viedo.65fc26c3.png";